import { createSelector } from '@opengov/compose-app/reselect';
import { chartSelector } from '../state';
export var getContainerWidth = createSelector(chartSelector, function (state) {
  return state.containerWidth;
});
export var getChartData = createSelector(chartSelector, function (state) {
  return state.chartData;
});
export var getLegendData = createSelector(chartSelector, function (state) {
  return state.legendData;
});
export var getSelectedCategory = createSelector(chartSelector, function (state) {
  return state.selectedCategory;
});
export var getChartContainerRect = createSelector(chartSelector, function (state) {
  return state.chartContainerRect;
});
export var getSelectedElements = createSelector(chartSelector, function (state) {
  return state.selectedElements;
});
export var getTooltip = createSelector(chartSelector, function (state) {
  return state.tooltip;
});
export var getSelectedPoint = createSelector(chartSelector, function (state) {
  return state.selectedPoint;
});
export var selectCategorizedByColumnForChart = createSelector(chartSelector, function (state) {
  return state.reportConfiguration.visualizationQuery.categorizedByColumn;
}); // basically, if we have a report configuration we are good to
// calculate everything

export var selectHaveDataToDisplay = createSelector(chartSelector, function (state) {
  return Boolean(state.reportConfiguration.reportId) && state.chartData.length !== 0;
});